<template>
  <TeamSelector
    ref="teamSelector"
    :disabled="disabled"
    :selectedTeamIds="selectedTeamIds"
    @select="handleTeamSelect"
  >
    <template v-slot:activator="{ selectedTeams, teams }">
      <v-select
        class="reports-teams-filter-container caption white"
        dense
        hide-details
        item-value="id"
        item-text="name"
        outlined
        readonly
        ref="teamSelectorActivator"
        :items="teams"
        :value="getSelectedTeam(selectedTeams)"
        :placeholder="$t('menu.selection.select_an_option')"
      >
        <template v-slot:label>
          <div class="white px-1">
            {{ $t('common.team_one') }}
          </div>
        </template>
      </v-select>
    </template>
  </TeamSelector>
</template>

<script>
import TeamSelector from '@/components/TeamSelector/TeamSelector.vue'

export default {
  name: 'TeamsFilter',

  components: { TeamSelector },

  props: {
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    selectedTeamId: { type: String, default: '' },
  },

  computed: {
    selectedTeamIds() {
      return this.selectedTeamId ? [this.selectedTeamId] : []
    },
  },

  methods: {
    getSelectedTeam(selectedTeams = []) {
      return selectedTeams[0]?.id || null
    },

    handleTeamSelect(teamArray) {
      this.$emit('select', teamArray[0])
    },
  },
}
</script>

<style lang="scss">
.reports-teams-filter-container {
  input:not([placeholder]) {
    max-width: 0px;
  }
}
</style>
